export const knowledgeBaseData = [
    {
        id: 1,
        title: "Quick questions are answered",
        knowledgeList: [
            {
                text: "Dream big, work hard, achieve more.",
                fileTextIcon: true,
            },
            {
                text: "Stars require darkness to shine.",
                fileTextIcon: true,
            },
            {
                fileTextIcon: true,
                badge: "New",
                text: "The key to happiness lies within, not in goods.",
            },
            {
                fileTextIcon: true,
                text: "Seek advancement rather than perfection.",
            },
            {
                text: "See More (40)",
            },
        ],
    },
    {
        id: 2,
        title: "Integrating wordPress with your website",
        knowledgeList: [
            {
                text: "Plugins and tools for seamless WordPress integration",
                fileTextIcon: true,
                badge: "Review",
            },
            {
                fileTextIcon: true,
                text: "advantages of using WordPress as my website's CMS",
            },
            {
                fileTextIcon: true,
                text: "Desktop publishing software like Jully",
                badge: "Articles",
            },
            {
                fileTextIcon: true,
                text: "Making this the first true generator on the Internet.",
            },
            {
                text: "See More (90)",
            },
        ],
    },
    {
        id: 3,
        title: "WordPress site maintenance",
        knowledgeList: [
            {
                fileTextIcon: true,
                text: "WordPress Site Upkeep: Important Best Practises",
            },
            {
                fileTextIcon: true,
                text: "Regular Updates: WordPress Security and Stability",
                badge: "Closed",
            },
            {
                fileTextIcon: true,
                text: "Backup Fundamentals: Protecting Your Website Data",
            },
            {
                fileTextIcon: true,
                text: "The Essential Maintenance for a Thriving Website",
            },
            {
                text: "See More (50)",
            },
        ],
    },
    {
        id: 4,
        title: "Meta tags in wordPress",
        knowledgeList: [
            {
                text: "The article WordPress Site Care: A Recipe for Success",
                fileTextIcon: true,
                badge: "Popular",
            },
            {
                fileTextIcon: true,
                text: "Security Scan: Protecting Against Vulnerabilities.",
            },
            {
                fileTextIcon: true,
                text: "SEO and Site Speed: Improving User Experience",
            },
            {
                fileTextIcon: true,
                text: "Broken Links: Fixing for Improved Navigation",
            },
            {
                text: "See More (90)",
            },
        ],
    },
    {
        id: 5,
        title: "WordPress in your language",
        knowledgeList: [
            {
                text: "Discover WordPress Themes: Improve Website Design",
                fileTextIcon: true,
            },
            {
                text: "Making the Best Decision: WordPress vs. Other CMS",
                fileTextIcon: true,
            },
            {
                text: "Using Widgets to Your Advantage: Creating a Custom Website",
                fileTextIcon: true,
            },
            {
                fileTextIcon: true,
                text: "Essential WordPress Plugins: Easily enhance",
                badge: "Closed",
            },
            {
                text: "See More (50)",
            },
        ],
    },
    {
        id: 6,
        title: "Know your sources",
        knowledgeList: [
            {
                fileTextIcon: true,
                text: "First, get the issue resolved. Write the code after that.",
            },
            {
                fileTextIcon: true,
                text: "It has a more-or-less normal distribution of letters",
            },
            {
                text: "The writing of programmes must be simple",
                fileTextIcon: true,
                badge: "Article",
            },
            {
                fileTextIcon: true,
                text: "Coding involves logic and creativity in addition to merely writing code",
            },
            {
                text: "See More (26)",
            },
        ],
    },
    {
        id: 7,
        title: "Validating a Website",
        knowledgeList: [
            {
                text: "Build your website to make users happy",
                fileTextIcon: true,
                badge: "Review",
            },
            {
                fileTextIcon: true,
                text: "Your website is your front door online",
            },
            {
                text: "Make sure your website is easy to use and simple",
                fileTextIcon: true,
                badge: "Closed",
            },
            {
                fileTextIcon: true,
                text: "Update, innovate, and enhance your website",
            },
            {
                text: "See More (10)",
            },
        ],
    },
    {
        id: 8,
        title: "Quick questions are answered",
        knowledgeList: [
            {
                fileTextIcon: true,
                text: "Coding: turning caffeine into lines of brilliance.",
            },
            {
                text: "Code is the poetry of logical expression.",
                fileTextIcon: true,
                badge: "Popular",
            },
            {
                text: "Coding is the art of engineering",
                fileTextIcon: true,
                badge: "Review",
            },
            {
                text: "Every screen size is accommodated with a responsive website",
                fileTextIcon: true,
            },
            {
                text: "See More (25)",
            },
        ],
    },
    {
        id: 9,
        title: "Integrating wordPress with your website",
        knowledgeList: [
            {
                text: "The core of your online presence is your website",
                fileTextIcon: true,
            },
            {
                text: "Your website is a 24/7 marketing tool",
                fileTextIcon: true,
            },
            {
                text: "Build a website that turns users into buyers",
                fileTextIcon: true,
            },
            {
                text: "User experience determines a website's success",
                badge: "On hold",
                fileTextIcon: true,
            },
            {
                text: "See More (34)",
            },
        ],
    },
];
